import { render } from "./TabunganView.vue?vue&type=template&id=2458b761"
import script from "./TabunganView.vue?vue&type=script&lang=js"
export * from "./TabunganView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__